import { useCallback } from 'react';
import { type Href, useFocusEffect, useRouter } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

// Waits a frame so the Account tab's `popToTopOnBlur` runs before the redirect pushes into it.
export const DeferredRedirect = (props: Props) => {
  const { href } = props;

  const router = useRouter();

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const redirectOnNextFrame = useCallback(() => {
    const frame = requestAnimationFrame(() => {
      router.replace(href, { withAnchor: true });
    });

    return () => {
      cancelAnimationFrame(frame);
    };
  }, [href, router]);

  // ─── Effects ───────────────────────────────────────────────────────────────

  useFocusEffect(redirectOnNextFrame);

  // ───────────────────────────────────────────────────────────────────────────

  return null;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  href: Href;
};
